<template>

  <div style="position: relative">
    <div v-for="notification in notifications" :key="notification.id" class="notifications-item">
      <div class="notifications-item-date mb-2">
        {{ notification.createdAt | date }}
      </div>

      <div class="notifications-item-title line-clamp mb-2">
        {{ notification.title }}
      </div>

      <div class="notifications-item-content notification-html" v-html="notification.content">
      </div>
    </div>

    <Loading :load="load" style="position: absolute; cursor: default"/>

  </div>

</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Loading from '@/components/shares/Loading'

  export default {
    beforeDestroy() {
      clearInterval(this[this.$name() + 'SetInterval'])
    },
    components: { Loading },
    computed: {
      notifications() {
        return this.getModels || []
      }
    },
    created() {
      this.addOrderBy('createdAt')
      this.find()
      this[this.$name() + 'SetInterval'] = setInterval(() => {
        this.find()
      }, 20000)
    },
    data() {
      return {
        keyModel: 'headerNotification',
        load: false,
        nameModel: 'Notification'
      }
    },
    methods: {
      closeLoad() {
        this.load = false
      },
      find() {
        const key = this.$name()
        const notifications = this.$ls.get(key)
        if (notifications && notifications.length > 0) {
          this.setModels(notifications)
          return
        }

        this.asyncTemplateSelect({
          after: ({ models }) => {
            this.$ls.set(key, models, { minutes: 1 })
          },
        })
      },
      openLoad() {
        this.load = true
      }
    },
    mixins: [ModelMapper],
    name: 'Notification'
  }
</script>

<style scoped>

.line-clamp {
  width:100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  background: var(--white-bg);
}

/* O HTML da campanha traz cor e fundo inline pensados para o popup/e-mail
   (texto branco, cinza claro, roxo). Aqui eles sao anulados para o texto seguir
   a cor do tema, claro ou escuro, e nao sumir no fundo do sininho. #85216 */
.notification-html {
  overflow-wrap: anywhere;
}

.notification-html ::v-deep * {
  color: inherit !important;
  background: transparent !important;
}

.notification-html ::v-deep a {
  color: var(--primary-color) !important;
  text-decoration: underline;
}

.notification-html ::v-deep a:hover {
  color: var(--primary-color-hover) !important;
}

.notification-html ::v-deep img {
  max-width: 100%;
  height: auto;
}

</style>
